import { withStyles } from '@material-ui/core'
import React from 'react'

const Dot = ({ classes, color }) => {
  return <div className={classes.dot} style={{ backgroundColor: color }}></div>
}

const styles = () => ({
  dot: {
    backgroundColor: 'blue',
    width: '8px',
    height: '8px',
    borderRadius: '30px'
  }
})

export default withStyles(styles)(Dot)
